import { getRequest, postRequest } from '@/lib/request'
import { VCardFormSchema } from '@/lib/schemas/authUser/vCard'
import { IdentityFormValues } from '@/lib/schemas/onboarding/identity'

export const getConstants = () => {
  return getRequest('/common/constants')
}

export const onboardingValidation = (data: Partial<VCardFormSchema> | IdentityFormValues) => {
  return postRequest('/companies/confirm-registration/validate', { vcard: data })
}
